module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "p-404 u-bg--white-near"
  }, [_c('div', {
    staticClass: "u-flex u-flex-ai--center u-flex-jc--center u-fit-v"
  }, [_c('div', {
    staticClass: "u-flex u-flex-fd--column u-flex-ai--center"
  }, [_c('span', {
    staticClass: "t-text--xs-l t-fweight--bold u-uppercase u-color--gray"
  }, [_vm._v("404 not found")]), _vm._v(" "), _c('router-link', {
    staticClass: "u-relative u-marg-t-md t-link t-text--xs-l t-fweight--bold u-uppercase u-click-area-xxs",
    attrs: {
      "to": _vm.$root.getPageURLFromName('home')
    }
  }, [_vm._v("\n                Back to home\n            ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f895222"}!./src/scripts/components/page-404/template.html
// module id = 144
// module chunks = 0